export const columns = [
  {
    field: 'buyerName',
    headerName: 'Buyer Name',
    flex: 1,
    sortable: true,
  },
  {
    field: 'contactName',
    headerName: 'Contact Name',
    flex: 1,
    sortable: true,
  },
  {
    field: 'email',
    headerName: 'Email Address',
    flex: 1,
    sortable: true,
  },
  {
    field: 'createdOn',
    headerName: 'Created On',
    flex: 1,
    sortable: true,
    type: 'dateTime',
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    flex: 1,
    sortable: true,
  },
];

export const operationResultMessage = {
  DELETE_CONTACT: {
    SUCCESS: 'Contact was successfully deleted.',
    ERROR: 'Contact was not deleted because: ',
  },
  ADD_CONTACT: {
    SUCCESS: 'Contact was successfully saved.',
    ERROR: 'Contact was not saved because: ',
  },
  UPDATE_CONTACT: {
    SUCCESS: 'Contact was successfully updated.',
    ERROR: 'Contact was not updated because: ',
  },
};

export const pageSize = 20;
